document.addEventListener('DOMContentLoaded', function() {

    view_switcher();

    window.addEventListener('collection:updated', (event) => {
        setTimeout(function(){
            updateSwitcherButtons();
            view_switcher();
        }, 0 );
    });
});

function updateSwitcherButtons() {
    var container = document.getElementById('ProductGridContainer');
    var gridBtn = document.querySelector('.switcher-grid');
    var listBtn = document.querySelector('.switcher-list');
    
    if (!container || !gridBtn || !listBtn) return;

    console.log( container );
    if (container.classList.contains('list-view')) {
        listBtn.classList.add('switcher-active');
        gridBtn.classList.remove('switcher-active');
    } else {
        gridBtn.classList.add('switcher-active');
        listBtn.classList.remove('switcher-active');
    }
}

function view_switcher() {
    // Use event delegation for dynamically loaded switcher buttons
    if ( document.querySelector('.products-switcher') ) {
        document.querySelector('.products-switcher').addEventListener('click', function(event) {
            var button = event.target.closest('.switcher-button');
            if (!button) return;

            if (button.classList.contains('switcher-active')) {
                return;
            }

            // Remove active class from all buttons
            document.querySelectorAll('.products-switcher .switcher-button').forEach(function(btn) {
                btn.classList.remove('switcher-active');
            });
            // Add active class to the clicked button
            button.classList.add('switcher-active');

            // Check data-view attribute to determine list or grid
            var view = button.getAttribute('data-view'); // e.g., 'list' or 'grid'

            var gridContainer = document.getElementById('ProductGridContainer');
            if (view === 'list') {
                gridContainer.classList.add('list-view');
                gridContainer.classList.remove('grid-view');
            } else {
                gridContainer.classList.add('grid-view');
                gridContainer.classList.remove('list-view');
            }
        });
    }
}